import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { StoreService } from 'src/app/services/store.service';

@Pipe({
  name: 'CustomCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  currencyCode: string = 'GBP';
  display: string = 'symbol';
  digitsInfo: string = '1.2-2';

  constructor(
    private currencyPipe: CurrencyPipe,
    private storeService: StoreService
  ) {
    this.storeService.restaurantData.subscribe(data => {
      if (Object.getOwnPropertyNames(data).length !== 0) {
        this.currencyCode = data.restaurant_data.currency;
      }
    });
    this.display = this.currencyCode === 'BDT' ? 'symbol-narrow' : 'symbol';
    this.digitsInfo = this.currencyCode === 'BDT' ? '1.0-0' : '1.2-2';
  }

  transform(value: any, currencyCode = this.currencyCode, display = this.display, digitsInfo = this.digitsInfo): string {
    if (!value || value === null) {
      return this.currencyPipe.transform(0, currencyCode, display, digitsInfo)
    };
    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo);
  }

}
